import { Skeleton } from "@layer/ui/components";
import { cn } from "@layer/utils/cn";
import { Fragment } from "react";

type LoadingSkeletonProps = {
	//columnWidths to contain fraction values
	sections: Array<{ rows: number; columnWidths: string[] }>;
	rowHeight?: number;
	gridGap?: number;
};
export const LoadingSkeleton = ({
	sections,
	rowHeight = 6,
	gridGap = 2,
}: LoadingSkeletonProps) => {
	return (
		<section
			className={cn(
				`gap-y-${gridGap}`,
				"flex h-full w-full flex-col p-2",
			)}
		>
			{sections.map((section, sectionIndex) => (
				<Fragment key={`section-${sectionIndex}`}>
					{Array.from({ length: section.rows }).map(
						(_row, rowIndex) => (
							<div
								key={`row-${sectionIndex}-${rowIndex}`}
								className={cn(
									`gap-${gridGap}`,
									section.columnWidths.length > 1 &&
										"flex justify-start",
								)}
							>
								{section.columnWidths.map(
									(columnWidth, columnIndex) => (
										<Skeleton
											key={`skeleton-${sectionIndex}-${rowIndex}-${columnIndex}`}
											className={cn(
												`h-${rowHeight}`,
												section.columnWidths.length >
													1 && `w-${columnWidth}`,
											)}
										/>
									),
								)}
							</div>
						),
					)}
					{sectionIndex !== sections.length - 1 && (
						<hr className="my-2" key={`hr-${sectionIndex}`} />
					)}
				</Fragment>
			))}
		</section>
	);
};
